import UIErrorMessage from '$shared/constants/UIErrorMessage';

export class CurrencyValidator {
  static validate(value?: string | null): void {
    if (!value) return;

    const parsedValue = value.replace(/,/g, '');
    if (isNaN(parsedValue)) throw new Error(UIErrorMessage.InvalidNumber);

    if (parseFloat(parsedValue) > 0) return;

    throw new Error(UIErrorMessage.NumberMustBePositive);
  }
}
